// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"member-operations__MemberTaskMenu__menuButton","MedKitTheme":"member-operations__MemberTaskMenu__MedKitTheme"};